import {styled} from '@mui/material'
import {Texts} from 'appearance'
import {useI18n} from 'store/Store'

const HistoryRequestStatus = ({value}) => {
    const {i18n} = useI18n()

    return (
        <Container>
            <StatusText>
                {value && i18n.t(`clientRequests.${value}`)}
            </StatusText>
        </Container>
    )
}

export default HistoryRequestStatus

const Container = styled('div')`
    display: flex;
    align-items: center;
    gap: 6px;
`

const StatusText = styled(Texts.RegularText)`
    font-size: 0.875rem;
`
